import React, { useState } from "react";
import { blogData } from "../../blogs";
import { BlogTile } from "../../pages/Blog";
import { GoChevronLeft, GoChevronRight } from "react-icons/go";
import TopicsContainer from "./TopicsContainer";
const BlogCarausel = ({ prev, next }) => {
  const map = [0, 0, 0];
  const [index, setIndex] = useState(0);

  const showNext = () => {
    setIndex(index + map.length);
  };

  const showPrev = () => {
    setIndex(index - map.length);
  };

  return (
    <>
      <div className="row">
        <div className="col-12">
          <TopicsContainer />
        </div>
      </div>
      <div className="row blogCarausel" style={{ minHeight: "400px" }}>
        <div className="col-1 d-flex justify-content-center align-items-center">
          <GoChevronLeft
            style={{
              fontSize: "2rem",
              color: `${index <= 0 ? "grey" : "black"}`,
              cursor: "pointer",
            }}
            onClick={index <= 0 ? null : showPrev}
          />
        </div>
        <div className="col-10 d-flex justify-content-around">
          {map.map((i, idx) =>
            blogData[index + idx] ? (
              <BlogTile blog={blogData[index + idx]} carausel={true} />
            ) : null
          )}
        </div>
        <div className="col-1 d-flex justify-content-center align-items-center">
          <GoChevronRight
            style={{
              cursor: "pointer",
              fontSize: "2rem",
              color: `${index >= blogData.length - 1 ? "grey" : "black"}`,
            }}
            onClick={index >= blogData.length - 1 ? null : showNext}
          />
        </div>
      </div>
      <div className="row blogNavigators">
        {next ? (
          <div className="col-12">
            <h4 className="font-weight-bold my-5">Next Read</h4>

            <BlogTile blog={next} />
          </div>
        ) : null}
        {prev ? (
          <div className="col-12">
            <h4 className="font-weight-bold my-5">Previous Read</h4>
            <BlogTile blog={prev} />
          </div>
        ) : null}
      </div>
    </>
  );
};

export default BlogCarausel;
